import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { PackageSortProperty } from "@/shared/domain";

export const packageTableColumns: TableColumProps<MyBrokerApi.DocumentsPackageToSign, PackageSortProperty>[] = [
    {
        sortableKey: "name",
        label: fakeI18n.t("Common.Title"),
        width: 30,
    },
    {
        unsortableKey: "documentsList.policyHolder",
        notSortable: true,
        label: fakeI18n.t("Common.Concerns"),
        width: 20,
    },
    {
        sortableKey: "requestDate",
        label: fakeI18n.t("Common.RequestDate"),
        width: 15,
    },
    {
        // @ts-ignore - to be added on BE side
        sortableKey: "expirationDate",
        label: fakeI18n.t("Common.ExpirationDate"),
        width: 15,
    },
    {
        notSortable: true,
        width: 15,
    },
];
